import { render, staticRenderFns } from "./c-svg-icons.vue?vue&type=template&id=3dd21562&scoped=true"
import script from "./c-svg-icons.vue?vue&type=script&setup=true&lang=js"
export * from "./c-svg-icons.vue?vue&type=script&setup=true&lang=js"
import style0 from "./c-svg-icons.vue?vue&type=style&index=0&id=3dd21562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd21562",
  null
  
)

export default component.exports